export interface ArchiveEvent {
  id: string;
  code: string;
  title: string;
  category: string;
  status: string;
  platform: string;
  firstSeen: string;
  heat: string;
  comments: number;
  summary: string;
  image?: string;
  size: "large" | "small";
}

export interface TraceStep {
  marker: string;
  time: string;
  platform: string;
  actor: string;
  title: string;
  desc: string;
}

export interface PlatformStat {
  name: string;
  percent: number;
  count: number;
  role: string;
}

export interface HotComment {
  user: string;
  level: string;
  text: string;
  likes: number;
  time: string;
  event: string;
}

export interface RankItem {
  rank: number;
  title: string;
  time: string;
  trend: string;
}

export const tickerItems: string[] = [
  "07:40｜事件 H-2418 出现首张现场合影，最早发布账号已完成定位",
  "08:05｜图文社区 B 搬运帖上线，发布时间晚于首发 25 分钟",
  "08:22｜相关词条进入讨论榜前 5，单小时讨论量增长 4 倍",
  "09:10｜首发原帖链接失效，快照已归档，泄露链条关键节点留存",
  "10:30｜事件 H-2409 拍摄背景核实完成，确认为公开活动现场",
  "11:05｜事件 H-2421 新增 3 条二传路径，来源指向同一账号",
  "12:00｜今日新增归档照片 37 张，其中 6 起仍在追踪首发出处",
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=stylized%20abstract%20dark%20editorial%20collage%20of%20scattered%20newspaper%20clippings%20and%20blurred%20photo%20frames%2C%20burnt%20orange%20and%20amber%20glows%2C%20heavy%20film%20grain%20texture%2C%20moody%20cinematic%20atmosphere%2C%20no%20people%20no%20faces%20no%20readable%20text%2C%20conceptual%20illustration%2C%20wide%20composition&width=1600&height=760&seq=hl-hero-bg-2026&orientation=landscape";

export const statCards: { value: string; label: string; sub: string }[] = [
  { value: "1,286", label: "累计归档事件", sub: "按事件编号归档" },
  { value: "37", label: "今日新增照片", sub: "较昨日 +12" },
  { value: "9", label: "追踪中的首发路径", sub: "源头尚未确认" },
  { value: "4", label: "已核实拍摄背景", sub: "均为公开活动现场" },
];

export const entryLinks: { label: string; desc: string }[] = [
  { label: "首发出处", desc: "最早出现在哪个平台" },
  { label: "泄露源头", desc: "原帖与快照留存" },
  { label: "谁爆的", desc: "首发账号对比" },
  { label: "拍摄背景", desc: "场地与时间线还原" },
  { label: "最早出现", desc: "时间戳逐一比对" },
];

export const archiveFilters: string[] = ["全部归档", "追踪中", "已核实", "待确认", "已失效"];

export const archiveEvents: ArchiveEvent[] = [
  {
    id: "h-2418",
    code: "H-2418",
    title: "后台区域合影流出：首张照片与二次搬运相差 25 分钟",
    category: "首发追踪",
    status: "追踪中",
    platform: "短视频平台 A",
    firstSeen: "09-12 07:40",
    heat: "9.4",
    comments: 1286,
    summary:
      "从首张照片的上传时间与设备参数推断，最早出现时间早于二次搬运 25 分钟，拍摄背景指向一场公开活动的后台区域，首发账号已完成初步定位。",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20conceptual%20still%20life%20of%20a%20vintage%20camera%2C%20magnifying%20glass%20and%20folded%20newspaper%20clippings%20on%20a%20dark%20walnut%20desk%2C%20warm%20amber%20rim%20light%2C%20investigative%20editorial%20mood%2C%20no%20people%20no%20faces%2C%20cohesive%20warm%20brown%20and%20orange%20palette%2C%20subtle%20film%20grain&width=800&height=520&seq=hl-card-2418&orientation=landscape",
    size: "large",
  },
  {
    id: "h-2409",
    code: "H-2409",
    title: "拍摄背景已核实为公开活动现场",
    category: "拍摄背景",
    status: "已核实",
    platform: "图文社区 B",
    firstSeen: "09-11 21:15",
    heat: "8.1",
    comments: 642,
    summary: "通过场地布置细节与当天活动流程比对，确认照片拍摄于公开活动现场，非私人空间。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20toned%20close%20up%20of%20stacked%20archived%20paper%20documents%20and%20folder%20tabs%20under%20soft%20amber%20light%2C%20editorial%20texture%2C%20no%20readable%20text%2C%20no%20people%2C%20moody%20shallow%20depth%20of%20field&width=420&height=320&seq=hl-thumb-2409&orientation=landscape",
    size: "small",
  },
  {
    id: "h-2421",
    code: "H-2421",
    title: "三条二传路径指向同一账号",
    category: "泄露源头",
    status: "追踪中",
    platform: "社交平台 C",
    firstSeen: "09-12 06:02",
    heat: "7.6",
    comments: 431,
    summary: "三条搬运路径的发布时间与配文高度一致，来源指向同一账号，疑似同批外流。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20dark%20moody%20timeline%20of%20torn%20paper%20strips%20and%20a%20clock%20face%20on%20a%20wooden%20surface%2C%20warm%20amber%20light%2C%20conceptual%20no%20readable%20text%2C%20no%20people%2C%20film%20grain%20texture&width=420&height=320&seq=hl-thumb-2421&orientation=landscape",
    size: "small",
  },
  {
    id: "h-2402",
    code: "H-2402",
    title: "首发帖删除后，快照仍可完整检索",
    category: "泄露源头",
    status: "已核实",
    platform: "论坛 D",
    firstSeen: "09-10 23:48",
    heat: "6.9",
    comments: 356,
    summary: "原始发布帖已删除，但归档快照保留了配文与发布时间，可用于还原首发顺序。",
    size: "small",
  },
  {
    id: "h-2425",
    code: "H-2425",
    title: "标题被改写，导致来源一度误判",
    category: "谁爆的",
    status: "待确认",
    platform: "图文社区 B",
    firstSeen: "09-12 09:33",
    heat: "6.2",
    comments: 288,
    summary: "二次搬运改写了标题关键词，使检索结果指向错误来源，需以原始上传时间为准。",
    size: "small",
  },
  {
    id: "h-2411",
    code: "H-2411",
    title: "同设备连拍，首尾两张相隔 19 秒",
    category: "最早出现",
    status: "追踪中",
    platform: "短视频平台 A",
    firstSeen: "09-11 18:20",
    heat: "5.8",
    comments: 197,
    summary: "设备参数一致表明为同批连拍，首尾两张仅隔 19 秒，可据此锁定最早外流节点。",
    size: "small",
  },
];

export const traceSteps: TraceStep[] = [
  {
    marker: "T-0",
    time: "09-12 07:12",
    platform: "现场",
    actor: "拍摄者",
    title: "原始拍摄",
    desc: "公开活动现场后台区域，同设备连拍 7 张，场地细节与当天活动流程吻合。",
  },
  {
    marker: "T-1",
    time: "09-12 07:40",
    platform: "短视频平台 A",
    actor: "账号 @·4f",
    title: "首次上传",
    desc: "最早可出现的一张，发布时间距拍摄 28 分钟，判定为最可能的首发出处。",
  },
  {
    marker: "T-2",
    time: "09-12 08:05",
    platform: "图文社区 B",
    actor: "搬运账号",
    title: "二次搬运",
    desc: "标题被改写且未标注出处，时间晚于首发 25 分钟，属于典型二次扩散。",
  },
  {
    marker: "T-3",
    time: "09-12 08:22",
    platform: "社交平台 C",
    actor: "多账号",
    title: "扩散高峰",
    desc: "相关词条进入讨论榜前 5，单小时讨论量增长 4 倍，来源指向已趋于一致。",
  },
  {
    marker: "T-4",
    time: "09-12 09:10",
    platform: "短视频平台 A",
    actor: "首发账号",
    title: "原帖删除",
    desc: "首发链接失效，归档快照已留存，泄露链条的关键节点得以保全。",
  },
];

export const platformStats: PlatformStat[] = [
  { name: "短视频平台 A", percent: 42, count: 536, role: "首发高频" },
  { name: "图文社区 B", percent: 26, count: 334, role: "搬运集中" },
  { name: "社交平台 C", percent: 18, count: 231, role: "扩散主力" },
  { name: "论坛 D", percent: 14, count: 185, role: "旧帖回捞" },
];

export const posterRanks: { name: string; events: number; role: string; rate: string }[] = [
  { name: "账号 @·4f", events: 26, role: "首发高频", rate: "73%" },
  { name: "影像搬运站", events: 21, role: "搬运集中", rate: "58%" },
  { name: "路透小号", events: 17, role: "二次扩散", rate: "44%" },
  { name: "档案回捞组", events: 12, role: "旧帖归档", rate: "31%" },
];

export const hotComments: HotComment[] = [
  {
    user: "瓜田观察员",
    level: "追踪者",
    text: "首发出处这条线其实很清楚，时间戳对不上的，一律先按搬运处理。",
    likes: 328,
    time: "12 分钟前",
    event: "H-2418",
  },
  {
    user: "时间戳警察",
    level: "溯源组",
    text: "同一设备连拍这条很关键，首尾只差 19 秒，最早外流节点基本能锁定。",
    likes: 274,
    time: "34 分钟前",
    event: "H-2411",
  },
  {
    user: "只看看不说话",
    level: "围观群众",
    text: "标题被改写过的那种最容易误判来源，还是要看原始上传时间和快照。",
    likes: 191,
    time: "1 小时前",
    event: "H-2425",
  },
  {
    user: "档案组小李",
    level: "溯源组",
    text: "原帖删了但快照还在，出处梳理反而更完整，建议按事件编号统一归档。",
    likes: 156,
    time: "1 小时前",
    event: "H-2402",
  },
  {
    user: "路人甲一号",
    level: "围观群众",
    text: "拍摄背景写清楚之后，很多误会就散了，公开活动的就别硬往私密场景带。",
    likes: 122,
    time: "2 小时前",
    event: "H-2409",
  },
  {
    user: "夜班吃瓜",
    level: "围观群众",
    text: "三条路径指向同一账号，基本可以判断是同批外流，等进一步核实。",
    likes: 98,
    time: "2 小时前",
    event: "H-2421",
  },
];

export const updateRanks: RankItem[] = [
  { rank: 1, title: "H-2418 后台合影首发出处确认", time: "07:40", trend: "新" },
  { rank: 2, title: "H-2421 二传路径锁定同一账号", time: "06:02", trend: "升" },
  { rank: 3, title: "H-2409 拍摄背景核实完成", time: "09-11", trend: "稳" },
  { rank: 4, title: "H-2402 快照记录完整留存", time: "09-10", trend: "升" },
  { rank: 5, title: "H-2425 标题改写导致误判", time: "09:33", trend: "新" },
];

export const hotTags: string[] = [
  "首发出处",
  "拍摄背景",
  "泄露链条",
  "搬运判定",
  "原帖快照",
  "时间戳比对",
  "最早出现",
  "同批外流",
];

export const sourcePlatforms: { name: string; count: number }[] = [
  { name: "短视频平台 A", count: 536 },
  { name: "图文社区 B", count: 334 },
  { name: "社交平台 C", count: 231 },
  { name: "论坛 D", count: 185 },
];

export const archiveNotes: { title: string; desc: string }[] = [
  { title: "按事件归档", desc: "每张照片归入对应事件编号，出处链条集中呈现。" },
  { title: "标注最早出现", desc: "以最早可检索的上传时间为准，标注首发平台与账号。" },
  { title: "保留快照记录", desc: "原帖删除后仍保留归档快照，便于回溯来源。" },
];